import { Injectable } from '@angular/core';
import { HttpClient, HttpContext } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@env/environment';
import { SKIP_AUTH } from '../../../core/interceptors/jwt.interceptor';

export interface AppartmentType {
  id: number;
  nom: string;
  description: string | null;
}

export interface ApartHotel {
  id: number;
  name: string;
  address: string;
}

export interface DocumentDto {
  id: number;
  name: string;
  contentType: string;
  documentUrl: string;
  entityOwnerId: number;
  entityOwnerName: string;
  description: string;
  content?: string;
  deleted: boolean;
}

export interface ApiApartment {
  id: number;
  type: string | null;
  name: string;
  numero: number;
  prixParNuit: number;
  statut: string;
  etage: number;
  numberOfPieces: number;
  apartHotel: ApartHotel | null;
  capacite: number;
  appartmentType: AppartmentType | null;
  equipments: any[];
  coverImage: DocumentDto | null;
  images: DocumentDto[];
}

export interface ApiApartmentMeta {
  page: number;
  size: number;
  totalElements: number;
  totalPages: number;
  hasNext: boolean;
  hasPrevious: boolean;
}

export interface ApiApartmentResponse {
  content: ApiApartment[];
  meta: ApiApartmentMeta;
}

@Injectable({
  providedIn: 'root'
})
export class ApartmentService {
  private readonly API_URL = environment.apiUrl;

  constructor(private http: HttpClient) {}

  getApartments(startDate?: string, endDate?: string): Observable<ApiApartmentResponse> {
    const params = new URLSearchParams();
    if (startDate) params.append('start', startDate);
    if (endDate) params.append('end', endDate);
    const queryString = params.toString();
    const url = `${this.API_URL}/frontOfficeController/apartmentsAvailable${queryString ? '?' + queryString : ''}`;
    return this.http.get<ApiApartmentResponse>(url, {
      context: new HttpContext().set(SKIP_AUTH, true)
    });
  }
}
